import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as cutil from "@utils/Cutil";
import { url } from "@recoil/Store";
import { useRecoilState } from "recoil";
export default function SubMenus(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const [urls, setUrl] = useRecoilState(url);
    const { item } = props;
    return (_jsx(_Fragment, { children: _jsx("div", Object.assign({ className: "sub-menu" }, { children: _jsx("div", Object.assign({ className: "container" }, { children: _jsx("ul", { children: item.depth1.subMenus.map((val) => (_jsx("li", Object.assign({ className: `${val.menuId === urls.depth2.menuId ? "active" : ""}`, onClick: (e) => cutil.handleUrl(e, item.depth1, val, navigate, setUrl) }, { children: _jsx("a", Object.assign({ href: "#" }, { children: val.menuName })) }), val.menuId))) }) })) })) }));
}
